import { post } from './http'
import store from '@/store'

export const getCates = async parents => {
  try {
    const res = await post('index/Common/getCates', {
      parent_no: 'cate_meta'
    })
    let parents_no = res.data.map(d => d.no)
    parents_no = JSON.stringify(parents_no)
    const cates = await post('index/Common/getCates', {
      parents_no
    })
    store.dispatch('updateCates', cates.data)
  } catch(err) {

  }
  
}
